var exports = {
  "w": "x61f99309--5ac38e--loader",
  "u": "x61f99309--5ac38e--circle-spin",
};

module.exports = exports;
